import { createIcon } from './createIcon'

export const ArrowBackIcon = createIcon({
  displayName: 'ArrowBackIcon',
  viewBox: '0 0 22 14',
  path: [
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.70711 14.2071C7.31658 14.5976 6.68342 14.5976 6.29289 14.2071L0.292894 8.20711C-0.0976312 7.81658 -0.0976312 7.18342 0.292894 6.79289L6.29289 0.792894C6.68342 0.402369 7.31658 0.402369 7.70711 0.792894C8.09763 1.18342 8.09763 1.81658 7.70711 2.20711L3.41421 6.5H15C15.5523 6.5 16 6.94772 16 7.5C16 8.05229 15.5523 8.5 15 8.5L3.41421 8.5L7.70711 12.7929C8.09763 13.1834 8.09763 13.8166 7.70711 14.2071Z"
      fill="currentColor"
    />,
  ],
})
